"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepoRateType = exports.RepoRateFrequency = exports.RepoCurveType = exports.BusinessDayConvention = exports.DayCountBasisConvention = exports.PaymentRollConvention = exports.Outputs = void 0;
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
Object.defineProperty(exports, "PaymentRollConvention", { enumerable: true, get: function () { return financial_contracts_1.PaymentRollConvention; } });
Object.defineProperty(exports, "DayCountBasisConvention", { enumerable: true, get: function () { return financial_contracts_1.DayCountBasisConvention; } });
Object.defineProperty(exports, "BusinessDayConvention", { enumerable: true, get: function () { return financial_contracts_1.BusinessDayConvention; } });
var RepoCurveType;
(function (RepoCurveType) {
    RepoCurveType["RepoCurve"] = "RepoCurve";
    RepoCurveType["DepositCurve"] = "DepositCurve";
    RepoCurveType["LiborFixing"] = "LiborFixing";
})(RepoCurveType || (exports.RepoCurveType = RepoCurveType = {}));
var RepoRateFrequency;
(function (RepoRateFrequency) {
    RepoRateFrequency["Annual"] = "Annual";
    RepoRateFrequency["SemiAnnual"] = "SemiAnnual";
    RepoRateFrequency["Quarterly"] = "Quarterly";
    RepoRateFrequency["Monthly"] = "Monthly";
})(RepoRateFrequency || (exports.RepoRateFrequency = RepoRateFrequency = {}));
var RepoRateType;
(function (RepoRateType) {
    RepoRateType["MoneyMarket"] = "MoneyMarket";
    RepoRateType["Actual"] = "Actual";
    RepoRateType["Continuous"] = "Continuous";
    RepoRateType["Discount"] = "Discount";
    RepoRateType["Compounded"] = "Compounded";
    RepoRateType["SimpleJapanese"] = "SimpleJapanese";
    RepoRateType["CompoundedJapanese"] = "CompoundedJapanese";
})(RepoRateType || (exports.RepoRateType = RepoRateType = {}));
